import { observer } from "mobx-react-lite";
import { Button, Modal } from "@heroui/react";
import { contractorDetailStore } from "@/stores/ContractorDetailStore";

const UnsavedStepModal: React.FC = observer(() => {
  const { legal } = contractorDetailStore;
  const { unsavedWarning } = legal.drawer;
  const { isSaving } = legal.submit;

  return (
    <Modal.Backdrop
      isOpen={unsavedWarning.show}
      onOpenChange={(v) => {
        if (!v) legal.drawer.dismissUnsavedWarning();
      }}
    >
      <Modal.Container>
        <Modal.Dialog className="scd-unsaved-modal">
        <Modal.Header>
          <Modal.Heading>Несохранённые изменения</Modal.Heading>
        </Modal.Header>
        <Modal.Body>
          <p className="scd-unsaved-modal__text">
            На текущем шаге есть заполненные данные, которые ещё не сохранены.
            Сохранить их перед переходом или продолжить без сохранения?
          </p>
        </Modal.Body>
        <Modal.Footer className="scd-unsaved-modal__footer">
          <Button
            variant="secondary"
            onPress={() => legal.confirmUnsavedNavigate()}
          >
            Продолжить без сохранения
          </Button>
          <Button
            variant="primary"
            onPress={() => legal.saveAndNavigateToStep()}
            isDisabled={isSaving}
          >
            {isSaving ? "Сохранение..." : "Сохранить"}
          </Button>
        </Modal.Footer>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
});

UnsavedStepModal.displayName = "UnsavedStepModal";
export default UnsavedStepModal;
